// @flow

import React, { Suspense } from 'react';

import LoadingIndicator from '../../components/LoadingIndicator';

const Escalations = React.lazy(() => import('./index'));

const EscalationsLoadable = () => (
  <div>
    <Suspense fallback={<LoadingIndicator />}>
      <Escalations />
    </Suspense>
  </div>
);

export default EscalationsLoadable;
